export default __webpack_public_path__ + "static/media/Profile.a8b0e54d.svg";